import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { PaymentMethodResource } from "@exonn/js-sdk";

export const module: ModuleOptions<PaymentMethodResource> = {
  resource: ResourceEnum.PaymentMethod,
  bigIcon: <span className={"icon-20-pay_metd"} />,
  smallIcon: <span className={"icon-15-pay_metd"} />,
};
